<div class="fc-ac t-sm bold white p-h10 br-pill">{{ text }}</div>